import { getApiBaseUrl } from "../config/runtimeConfig";

const apiBaseUrl = getApiBaseUrl();

export class ApiError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

// [2.4.1] Árvore de categorias de despesa (2 níveis: raiz → subcategorias).
export interface ExpenseCategoryNode {
  id: number;
  code: string;
  name: string;
  sortOrder: number;
  parentId: number | null;
  /** true = custo de estrutura (nunca imputado a obra automaticamente); false = de obra; null = por classificar. */
  isStructural: boolean | null;
}

export interface ExpenseCategoryInput {
  code: string;
  name: string;
  parentId?: number | null;
  sortOrder?: number | null;
  isStructural?: boolean | null;
}

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(response.status, text || response.statusText);
  }

  // 204 No Content (DELETE) → nada para desserializar.
  if (response.status === 204) {
    return undefined as T;
  }

  return (await response.json()) as T;
}

export function getExpenseCategoriesTree(): Promise<ExpenseCategoryNode[]> {
  return request<ExpenseCategoryNode[]>("/api/expense-categories");
}

export function createExpenseCategory(
  input: ExpenseCategoryInput,
): Promise<ExpenseCategoryNode> {
  return request<ExpenseCategoryNode>("/api/expense-categories", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
}

export function updateExpenseCategory(
  id: number,
  input: ExpenseCategoryInput,
): Promise<ExpenseCategoryNode> {
  return request<ExpenseCategoryNode>(`/api/expense-categories/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
}

export function deleteExpenseCategory(id: number): Promise<void> {
  return request<void>(`/api/expense-categories/${id}`, { method: "DELETE" });
}

// Sugere um slug a partir do nome: minúsculas, sem acentos, espaços→"-".
export function slugifyCategoryName(name: string): string {
  return name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
